<template>
	<div class="grid" v-if="items">
		<template v-for="(item, i) of items">
			<div v-if="visible(item)" class="col-12 md:col-3 xs:col-6 comp-grid">
				<router-link v-if="item.to" :to="item.to">
					<!-- :style="`background:${$utils.randomLightColor()}`" -->
					<div class="card nice-shadow-7 text-center">
						<div class="mb-2" style="width: auto">
							<Avatar :icon="item.icon" size="large" class="bg-primary-100" />
							<Badge severity="danger" style="position: absolute; margin: -6px;"
								v-if="item.badge && item.badge != '0'" :value="item.badge"></Badge>
						</div>
						<div class="font-medium text-xl font-black mb-2">{{ item.label }}</div>
					</div>
				</router-link>
				<a v-else-if="item.url" :href="resolveHref(item)" target="_blank" style="text-decoration:none">
					<div class="card nice-shadow-7 text-center">
						<div class="mb-2" style="width: auto">
							<Avatar :icon="item.icon" size="large" class="bg-primary-100" />
						</div>
						<div class="font-medium text-xl font-black mb-2">{{ item.label }}</div>
					</div>
				</a>
			</div>
		</template>
	</div>
</template>
<script>
import { StorageService } from '../services/storage';
export default {
	name: 'appsubmenu',
	props: {
		items: Array,
	},
	data() {
		return {}
	},
	methods: {
		resolveHref(item) {
			const url = item.url || '#';
			if (url.includes('{token}')) {
				const token = StorageService.getToken() || '';
				return url.replace('{token}', token);
			}
			return url;
		},
		visible(item) {
			return (typeof item.visible === 'function' ? item.visible() : item.visible !== false);
		}
	}
}
</script>